<style scoped lang="less">
.promisecenter {
	margin-top: 10px;

	/deep/ .el-step__head.is-wait {
		.el-step__icon.is-text {
			background: #dddddd;
			color: #fff;
		}
	}

	/deep/ .el-step.is-horizontal .el-step__line {
		top: 28px;
	}

	/deep/ .el-step__head.is-process {
		.el-step__icon.is-text {
			background-color: #37a000;
			color: #333;
			color: #fff;
			font-size: 1.4rem;
			border-color: transparent;
		}
	}

	/deep/ .el-step__head.is-process {
		.el-step__icon.is-success {
			border-color: #67c23a;
			background: #37a000 !important;
		}
	}

	/deep/ .is-success {
		.el-step__icon {
			background: #37a000 !important;
			color: #fff;
			font-size: 24px;
		}

		.el-step__line {
			background: #37a000;
		}
	}

	/deep/ .el-step__icon.is-text {
		padding: 1.6rem;
		border: 0;
	}
}
.knowscontent {
	border: 1px solid #ccc;
	border-radius: 10px;
	padding-bottom: 40px;

	.textarea {
		padding: 0 200px;
		margin: 20px 0;
		p {
			font-size: 16px;
			margin-bottom: 10px;
		}
	}

	.knowtitle {
		height: 40px;
		line-height: 40px;
		background-color: #37a000;
		color: #fff;
		border-top-left-radius: 10px;
		border-top-right-radius: 10px;
		padding-left: 20px;
		font-size: 16px;
	}
	background-color: #fff;
}

.courseitem {
	margin-top: 20px;

	/deep/ .el-collapse-item__header {
		border: none !important;
	}

	/deep/ .el-collapse-item__wrap {
		border: none !important;
	}

	.collapsetitle {
		// background-color: #37a000;
		// color: #fff;
		width: 100%;
		height: 40px;
		align-items: center;
		justify-content: space-between;
		display: flex;
		position: relative;

		.collabtn {
			margin-right: 40px;
			p {
				margin: 0 10px;
				text-decoration: underline;
				color: #409eff;
				box-sizing: border-box;
			}
		}

		.collapsetitlleft {
			display: flex;
			align-items: center;
			margin-left: 10px;

			img {
				width: 20px;
				height: 20px;
				margin-right: 10px;
			}

			.d-flex {
				margin-right: 10px;

				p {
					margin: 0 10px;
				}
			}
		}
	}

	.courseitemcenter {
		position: absolute;
		transform: translateX(-50%);
		left: 50%;

		p {
			margin: 0 10px;
		}
	}

	.courseitemchild {
		margin-left: 40px;
		position: relative;

		.courseitemright {
			margin-right: 30px;
			p {
				margin: 0 10px;
				text-decoration: underline;
				color: #409eff;
			}
		}

		/deep/ .el-collapse,
		.el-collapse-item__wrap,
		.el-collapse-item__header {
			border: none;
		}

		/deep/ .el-collapse-item {
			margin: 10px 0;
		}

		/deep/ .el-collapse-item__header {
			background-color: #f0f0f0;
		}

		.courseitemctitle {
			align-items: center;
			width: 100%;
			background-color: #f0f0f0;
			// color: #fff;
			justify-content: space-between;
			height: 40px;

			.courseitems {
				height: 40px;
				align-items: center;
				.bg-primary {
					// width: 60px;
					padding: 0 20px;
					height: 45px;
					display: flex;
					padding: 0 10px;
					color: #fff;
					align-items: center;
					justify-content: center;
					margin-right: 20px;
					background-color: #409eff !important;
				}
			}
		}
	}
}

.btnlist {
	margin-top: 10px;
	display: flex;
	margin-left: 10%;
}

/deep/ .el-drawer__header {
	color: #000;
	font-size: 20px;
}

/deep/ .el-dialog__body {
	padding: 0 20px 20px !important;
}

.addform {
	display: flex;
	justify-content: center;
	flex-direction: column;

	label:last-child {
		border-bottom: 1px solid #ccc;
	}

	label,
	.labelas {
		textarea {
			color: #333;
		}

		display: block;
		width: 100%;
		padding: 1rem 0;
		border-top: 1px solid #ccc;
		box-sizing: border-box;

		.labelchiles {
			margin: 0 auto;
			display: flex;
			align-items: center;

			p {
				// width: 5vw;
				text-align: right;
				margin-right: 1rem;
				color: rgb(74, 83, 94);
				font-size: 0.8rem;
			}
		}
	}
}

/deep/ .el-upload-list__item {
	width: 390px !important;
	height: 256px !important;
}
</style>
<template>
	<div>
		<titles titlename="添加课程" titlecontent="这里可以添加课程" :mbx="paths"></titles>
		<div class="promisecenter">
			<el-steps align-center :active="active" finish-status="success">
				<el-step title="第1步: 编辑课程信息"></el-step>
				<el-step title="第2步: 增加课程目录"></el-step>
				<el-step title="第3步: 添加考核考点"></el-step>
			</el-steps>
		</div>
		<div class="knowscontent" v-if="active == 0" style="width: 100%;margin-top: 20px;">
			<div class="knowtitle">考核要点</div>
			<div style="margin: 40px;width: 60%;">
				<el-form :rules="rules" ref="formone" label-width="200px" :model="formLabelAlign">
					<el-form-item label="课程名称" prop="CO_CoursesName"><el-input placeholder="请输入课程名称" v-model="formLabelAlign.CO_CoursesName"></el-input></el-form-item>
					<el-form-item label="专业" prop="CA_GUID">
						<el-select v-model="formLabelAlign.CA_GUID" placeholder="请选择专业" @change="getpolist()">
							<el-option v-for="item in prolist" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="岗位" prop="PR_GUID">
						<el-select v-model="formLabelAlign.PR_GUID" placeholder="请选择岗位">
							<el-option v-for="item in polist" :key="item.PR_GUID" :label="item.PR_ProfessionalName" :value="item.PR_GUID"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="等级" prop="IL_GUID">
						<el-select v-model="formLabelAlign.IL_GUID" clearable placeholder="请选择等级">
							<el-option v-for="item in gradeget" :key="item.IL_GUID" :label="item.IL_LevelTitle" :value="item.IL_GUID"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="课程封面图片" prop="CO_CoverImgUrl">
						<el-upload
							class="avatar-uploader"
							:action="baseurl1"
							list-type="picture-card"
							:file-list="fileList"
							:headers="{ Authorization: token }"
							:limit="1"
							accept=".jpg,.png"
							:on-success="handleAvatarSuccess"
							:before-upload="beforeAvatarUpload"
							:on-remove="handleRemove"
							:on-exceed="excehands"
							ref="upload"
						>
							<i class="el-icon-plus"></i>
						</el-upload>
						<el-dialog title="添加封面" :visible.sync="CoverImgUrlVisible" center width="80%">
							<div style="display: flex;align-items: center;justify-content: center;">
								<div style="display: flex;align-items: center;flex-direction: column;">
									<div style="width: 30rem;height: 30rem;">
										<vueCropper
											ref="cropper"
											:img="dialogImageUrl"
											:outputSize="option.outputSize"
											:outputType="option.outputType"
											:info="option.info"
											:full="option.full"
											:canMove="option.canMove"
											:canMoveBox="option.canMoveBox"
											:original="option.original"
											:autoCrop="option.autoCrop"
											:autoCropWidth="option.autoCropWidth"
											:autoCropHeight="option.autoCropHeight"
											:fixedBox="option.fixedBox"
											@realTime="realTime"
										></vueCropper>
									</div>
								</div>

								<div
									style="width: 30rem;
										display: flex;
										justify-content: space-evenly;
										align-items: center;
										margin-left: 1rem;"
								>
									<img :src="corappurl" alt="" style="width: 390px;height: 256px;border: 1px solid #ccc;" />
								</div>
							</div>
							<span slot="footer" class="dialog-footer">
								<el-button @click="clenrsa()">取 消</el-button>
								<el-button type="primary" @click="changeheadimg()">确 定</el-button>
							</span>
						</el-dialog>
					</el-form-item>
					<el-form-item label="课程学时(小时)" prop="CO_Learning">
						<el-input style="width: 200px;" min="0" clearable type="number" oninput="if(value>999)value=999" v-model="formLabelAlign.CO_Learning"></el-input>
					</el-form-item>
					<el-form-item label="课程权限">
						<el-radio-group v-model="formLabelAlign.CO_Privilage">
							<el-radio label="0">所有登录用户公开</el-radio>
							<el-radio label="1">对本院校用户公开</el-radio>
							<el-radio label="2">全网公开</el-radio>
							<el-radio label="3">私有</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="学生申请课程是否自动审核">
						<el-radio-group v-model="formLabelAlign.AutomaticallyApproveOrNot">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="课程简介">
						<el-input type="textarea" placeholder="请输入课程简介" rows="7" v-model="formLabelAlign.CO_Introduced" maxlength="300" show-word-limit></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div class="btnlist">
				<el-button-group>
					<el-button type="primary" @click="plus" v-if="active != 2">
						下一页
						<i class="el-icon-arrow-right el-icon--right"></i>
					</el-button>
				</el-button-group>
			</div>
		</div>

		<div class="knowscontent" style="margin-top: 40px;background-color: #fff;" v-if="active == 1">
			<div class="knowtitle">课程目录</div>
			<div style="padding: 10px 20px 40px;">
				<el-button @click="newcourser()" type="success" size="medium" icon="el-icon-circle-plus">新增章节</el-button>
				<div class="courseitem">
					<el-collapse accordion>
						<el-collapse-item v-for="(item, index) in formLabelAlign.chiHeadings" :key="item.HE_HeadingsText">
							<template slot="title">
								<div class="collapsetitle">
									<div class="collapsetitlleft">
										<img src="@/images/courses.svg" alt="" srcset="" />
										<div class="d-flex">
											<p>第{{ changechince(index + 1) }}章</p>
											<p style="width: 200px;">{{ item.HE_HeadingsText }}</p>
										</div>
									</div>
									<div class="d-flex courseitemcenter" style="color: #ccc;" :style="{ color: qutionszjs(index) == '作业已布置' ? '#00a5f8' : '#ccc' }">
										<p>{{ qutionszjs(index) }}</p>
									</div>
									<div class="d-flex collabtn">
										<p @click.stop="addpanel(index, $event)">
											<span class="el-icon-circle-plus"></span>
											添加节点
										</p>
										<p @click.stop="editpanel(index, $event, item.HE_HeadingsText)">
											<span class="el-icon-edit"></span>
											编辑
										</p>
										<p @click="changeparper(index, $event)">
											<span class="el-icon-document"></span>
											作业
										</p>
										<el-popconfirm title="这是一段章节确定删除吗？" @confirm="deletepanel(item)">
											<p slot="reference" @click="$event.stopPropagation()">
												<span class="el-icon-delete-solid"></span>
												删除
											</p>
										</el-popconfirm>
									</div>
								</div>
							</template>
							<div class="courseitemchild">
								<el-collapse accordion>
									<el-collapse-item v-for="(childitm, childidx) in item.chiHeadings" :key="childitm.HE_HeadingsText" :name="childitm.HE_HeadingsText">
										<template slot="title">
											<div class="d-flex courseitemctitle" @click="childitm.HE_IsJob ? $event.stopPropagation() : ''">
												<div class="d-flex courseitems">
													<div class="bg-primary">第{{ changechince(childidx + 1) }}节</div>
													<p class="mr-1" style="margin-left: 10px;width: 200px;">{{ childitm.HE_HeadingsText }}</p>
												</div>

												<div class="d-flex courseitemright">
													<p
														v-if="!childitm.HE_IsJob"
														@click="
															$event.stopPropagation();
															addresourmane(childitm, childidx, index);
														"
													>
														<span class="el-icon-circle-plus"></span>
														添加资源（资源库）
													</p>
													<p
														v-if="!childitm.HE_IsJob"
														@click="
															$event.stopPropagation();
															addresourmanemyupload(childitm, childidx, index);
														"
													>
														<span class="el-icon-circle-plus"></span>
														添加资源（自选资源）
													</p>
													<p
														@click="
															$event.stopPropagation();
															editsplens(childitm, childidx, index);
														"
													>
														<span class="el-icon-edit"></span>
														编辑
													</p>

													<el-popconfirm title="这是一段节点确定删除吗？" @confirm="deletechildpanel(childitm, index)">
														<p slot="reference" style="cursor: pointer;" @click="$event.stopPropagation()">
															<span class="el-icon-delete-solid"></span>
															删除
														</p>
													</el-popconfirm>
												</div>
											</div>
										</template>
										<div
											class="courseitemchild"
											v-for="(childmas, childidxs) in childitm.Sourcelist"
											:key="childmas.LR_FileName"
											style="margin: 10px 0 0 60px;"
										>
											<div class="d-flex courseitemctitle">
												<div class="d-flex courseitems">
													<div class="bg-primary">{{ childidx + 1 }}.{{ childidxs + 1 }}</div>
													<p class="mr-1" style="width: 200px;">{{ childmas.LR_Title }}</p>
												</div>
												<!-- <div class="d-flex courseitemcenter" style="color: #ccc;"><p>文件未上传</p></div> -->
												<div class="d-flex courseitemright">
													<el-popconfirm title="这是一段节点确定删除吗？" @confirm="deletechildroures(childmas, index, childidx)">
														<p slot="reference" style="cursor: pointer;" @click="$event.stopPropagation()">
															<span class="el-icon-delete-solid"></span>
															删除
														</p>
													</el-popconfirm>
												</div>
											</div>
										</div>
									</el-collapse-item>
								</el-collapse>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
			</div>
			<div class="btnlist">
				<el-button-group>
					<el-button @click="reduce" style="background-color: #8d9da6;margin-right: 10px;" type="primary" icon="el-icon-arrow-left">上一页</el-button>

					<el-button type="primary" @click="plus" v-if="active != 2">
						下一页
						<i class="el-icon-arrow-right el-icon--right"></i>
					</el-button>
					<el-button type="success" style="background-color: #00ca5e;" @click="plus" v-if="active == 2">完成</el-button>
				</el-button-group>
			</div>

			<el-dialog :title="contentstitle" :visible.sync="contentdialogTableVisible" :before-close="handleClose">
				<el-form :model="contentobj" label-position="left">
					<el-form-item label="名称"><el-input v-model="contentobj.name" placeholder="请输入名称" maxlength="30" autocomplete="off"></el-input></el-form-item>
					<el-form-item><el-button type="primary" @click="editspael()">立即修改</el-button></el-form-item>
				</el-form>
			</el-dialog>

			<el-drawer :title="drawertitle" :wrapperClosable="false" destroy-on-close :visible.sync="drawertable" direction="rtl" size="50%">
				<div>
					<chiocesqutions
						@custom-event="getqutions"
						@custom-eventedit="changequtions"
						:chiHeadactive="chiHeadactive"
						:chiHeadactivechilidx="chiHeadactivechilidx"
						:caguid="formLabelAlign.CA_GUID"
						:prguid="formLabelAlign.PR_GUID"
						:ilguid="formLabelAlign.IL_GUID"
						:list="qutionsobj.sqblist"
						:chocesname="chocesname"
					></chiocesqutions>
				</div>
			</el-drawer>

			<el-drawer :title="resourtitle" :wrapperClosable="false" destroy-on-close :visible.sync="resourtable" direction="rtl" size="50%">
				<div v-if="resourtitle == '添加资源'">
					<resourcemanege
						:caguid="formLabelAlign.CA_GUID"
						:prguid="formLabelAlign.PR_GUID"
						:ilguid="formLabelAlign.IL_GUID"
						@custom-event="getresourcenamege"
						@custom-eventedit="changeresourcenamege"
						:list="resourlist"
					></resourcemanege>
				</div>

				<div v-if="resourtitle == '添加自选资源'">
					<form class="addform">
						<label>
							<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
								<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">
									资源名称
									<span style="color: red;">*</span>
								</p>
								<input type="text" class="form-control" v-model="resourceobj.cr_resourcetitle" placeholder="请输入资源名称" />
							</div>
						</label>
						<label>
							<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
								<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">
									资源类型
									<span style="color: red;">*</span>
								</p>
								<select v-model="resourceobj.RT_GUID" class="form-control" id="exampleFormControlSelect1" @change="GetResourceSelects">
									<option value="">-- 请选择所属资源 --</option>
									<option v-for="(item, index) in rtlist" :key="item.RT_GUID" :label="item.RT_ResourceTitle" :value="item.RT_GUID">
										{{ item.RT_ResourceTitle }}
									</option>
								</select>
							</div>
						</label>
						<div class="labelas">
							<div class="col-xs-12 col-sm-10 col-md-8 col-lg-8 labelchiles">
								<p class="col-xs-6 col-sm-6 col-md-4 col-lg-2">
									上传资源
									<!-- <span style="color: red;">*</span> -->
								</p>

								<div v-loading="idlodings">
									<el-upload
										class="upload-demo"
										:action="baseurl1"
										ref="upload"
										drag
										:headers="{ Authorization: token }"
										:limit="1"
										:file-list="filelistszy"
										:before-upload="beforechangefilezy"
										:on-change="changefilezy"
										:on-success="successloadzy"
										:accept="zyaccept"
										:on-exceed="exceeds"
										:on-progress="progresszy"
									>
										<!-- :show-file-list="false" :auto-upload="false" -->
										<i class="el-icon-upload"></i>
										<div class="el-upload__text">
											将文件拖到此处，或
											<em>点击上传</em>
										</div>
									</el-upload>
								</div>
							</div>
						</div>

						<div style="display: flex;width: 100%;align-items: center;justify-content: center;">
							<el-button @click="setresour" type="primary" size="small">确认选择资源</el-button>
						</div>
					</form>
				</div>
			</el-drawer>
		</div>

		<div class="knowscontent" v-if="active == 2">
			<div class="knowtitle">考核要点</div>
			<div class="textarea">
				<p>课程背景</p>
				<el-input
					type="textarea"
					:placeholder="textareaplac"
					:autosize="{ minRows: 8, maxRows: 15 }"
					v-model="formLabelAlign.CO_Describe"
					maxlength="800"
					show-word-limit
				></el-input>
			</div>
			<div class="textarea">
				<p>课程目标</p>
				<el-input
					type="textarea"
					:placeholder="textareaplactow"
					:autosize="{ minRows: 8, maxRows: 15 }"
					v-model="formLabelAlign.CO_Objectives"
					maxlength="800"
					show-word-limit
				></el-input>
			</div>
			<div class="textarea">
				<p>课程设计原则</p>
				<el-input
					type="textarea"
					:placeholder="textareaplacthree"
					:autosize="{ minRows: 8, maxRows: 15 }"
					v-model="formLabelAlign.CO_Desing"
					maxlength="800"
					show-word-limit
				></el-input>
			</div>
			<div class="textarea">
				<p>考核要点内容</p>
				<tinymce-editor v-model="formLabelAlign.CO_Standard" ref="editor">
					<!--  * tinymce-editor 编辑富文本 
					 控制显示 dialogVisible
					 ref 获取
					 -->
				</tinymce-editor>
			</div>

			<div class="btnlist" style="margin-left: 12%;">
				<el-button-group>
					<el-button @click="reduce" type="primary" icon="el-icon-arrow-left" style="margin-right: 10px;background-color: #8d9da6;">上一页</el-button>

					<el-button type="primary" @click="plus" v-if="active != 2">
						下一页
						<i class="el-icon-arrow-right el-icon--right"></i>
					</el-button>
					<el-button type="success" style="background-color: #00ca5e;" @click="plus" v-if="active == 2">完成</el-button>
				</el-button-group>
			</div>
		</div>

		<div style="height: 60px;"></div>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import {
	changeUploadFileAsync,
	AddPaperTestQuestions,
	getGetProfList,
	getPositionList,
	changeGradeGet,
	changeAddCourse,
	getGetResourceTypes
} from '@/request/api/homesview/yunhomes/yunhom.js';

import { GetzyProfList } from '@/request/api/mange/mange.js';

import TinymceEditor from '@/components/Editor/Editor.vue';

import { setbaseurl, arabicToChinese } from '@/utils/utils.js';

import chiocesqutions from '@/components/chiocesqutions/questions.vue';

import resourcemanege from '@/components/chiocesqutions/resourcemanege.vue';

import { VueCropper } from 'vue-cropper';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			// 图片封面上传截图
			CoverImgUrlVisible: false,
			dialogImageObj: {},
			option: {
				img: '', // 裁剪图片的地址
				info: true, // 裁剪框的大小信息
				outputSize: 0.8, // 裁剪生成图片的质量
				outputType: 'jpeg', // 裁剪生成图片的格式
				canScale: false, // 图片是否允许滚轮缩放
				autoCrop: true, // 是否默认生成截图框
				autoCropWidth: 390, // 默认生成截图框宽度
				autoCropHeight: 256, // 默认生成截图框高度
				fixedBox: true, // 固定截图框大小 不允许改变
				fixed: false, // 是否开启截图框宽高固定比例
				fixedNumber: [5, 0], // 截图框的宽高比例
				full: true, // 是否输出原图比例的截图
				canMoveBox: true, // 截图框能否拖动
				original: true, // 上传图片按照原始比例渲染
				centerBox: true, // 截图框是否被限制在图片里面
				infoTrue: true // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
			},
			corappurl: '',
			dialogImageUrl: '',

			// 标题
			paths: [
				{
					path: '/usercenter/myuserpromise',
					name: '添加课程'
				}
			],
			resourceobj: {
				RT_GUID: '',
				cr_FileName: '',
				cr_resourcetitle: '',
				cr_OriginalFileUrl: '',
				cr_NewFileUrl: '',
				url: '',
				cr_FileSuffix: '',
				CR_Weighted: ''
			},
			// 弹窗
			contentstitle: '修改', // 修改对话框标题
			contentdialogTableVisible: false,
			chiHeadactive: 0, // 章节索引
			chiHeadactivechilidx: 0, // 节点索引
			chocesname: '', // 修改作业
			zyaccept: '', // 格式
			qutionsobj: {
				HE_HeadingsText: '章节作业',
				HE_SortNumber: 0,
				HE_IsJob: true,
				sqblist: []
			},
			resourlist: [],
			contentobj: {
				name: ''
			},
			rtlist: [],
			// 资源
			filelistszy: [],
			idlodings: false,
			// 抽屉
			drawertitle: '插入作业',
			drawerqutions: '题库选择',
			resourtitle: '添加资源',
			resourtable: false,
			drawertable: false,
			active: 0,
			formLabelAlign: {
				CO_CoursesName: '',
				CA_GUID: '',
				PR_GUID: '',
				IL_GUID: '',
				CO_CoverImgUrl: '',
				CO_Learning: '',
				CO_Privilage: '1',
				CO_Introduced: '',
				CO_Describe: '',
				CO_Objectives: '',
				CO_Standard: '',
				chiHeadings: [],
				CO_Desing: '',
				AutomaticallyApproveOrNot: '0'
			},

			rules: {
				CO_CoursesName: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
				CA_GUID: [{ required: true, message: '请选择专业', trigger: 'blur' }],
				PR_GUID: [{ required: true, message: '请选择岗位', trigger: 'blur' }],
				IL_GUID: [{ required: true, message: '请选择等级', trigger: 'blur' }],
				CO_CoverImgUrl: [{ required: true, message: '请选择封面图片', trigger: 'blur' }],
				CO_Learning: [{ required: true, message: '请输入课程学时', trigger: 'blur' }]
			},
			prolist: [],
			polist: [],
			gradeget: [],
			baseurl1: '',
			token: 'Bearer ' + localStorage.getItem('token'),
			zyaccept: '.jpg,.png,.svg',
			fileList: [],
			textareaplac:
				'例：本课程集构造、原理、应用于一体，侧重于满足培 养复兴号动车组司机熟练掌握设备操作方法、规范作 业过程的需求，兼顾复兴号动车组构造的学习。本课程主要内容包含复兴号动车组司机室设备操作 (CR400AF)，整备作业，CR400AF动车组重联及解编、 救援，动车组回送作业，CR400AF、CR400BF动车组简介。适用于动车组司机岗前培训、岗后适应性培训或 职工自学，也可以满足动车组专业的学生、 师资 班的学生学习复兴号动车组的需要。',
			textareaplactow:
				'例：《复兴号动车组司机操作及整备作业》课程的教学目标 \n 1， 培养学员熟练复兴号的整备作业流程 \n 2， 帮助学生掌握必要的专业理论知识 \n 3， 帮助学生提高技能水平',
			textareaplacthree:
				'例：《复兴号动车组司机操作及整备作业》共享课程的设计原则 \n 1， 寓价值观教育于知识性内容体系之中 \n 2， 紧扣高校特点聚焦重点内容 \n 3， 统筹三个层次的教学目标 \n 4， 注重知识的系统性'
		};
	},
	mounted() {
		this.baseurl1 = setbaseurl() + '/Courses/UploadFileAsync';
		this.init();
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		// 真实图片
		realTime(data) {
			// console.log(data);
			this.previews = data;
			let _this = this;
			this.$refs.cropper.getCropBlob(async data1 => {
				let formData = new FormData();
				if (data1) {
					var timestamp = new Date().getTime() + '.jpg';
					const newFile = new window.File([data1], timestamp);
					var src = window.URL.createObjectURL(newFile);
					_this.newfilenow = newFile;
					_this.corappurl = src;
				}
			});
		},
		changeheadimg() {
			// console.log(this.$refs.pictureUpload,"上传")
			this.$refs.upload.uploadFiles.forEach(item => {
				if (item.uid == this.dialogImageObj.uid) {
					item.url = this.corappurl;
				}
			});
			// console.log(this.newfilenow,"搞一11111")

			var form_data = new FormData();
			form_data.append('file', this.newfilenow);

			changeUploadFileAsync(form_data).then(res => {
				if (res.data.code == 1) {
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					let strlist = [];

					this.$refs.upload.uploadFiles[0].url = res.data.data.baseurl;
					// console.log(this.$refs.upload.uploadFiles,"搞一11111",res.data)
					// return
					// this.$refs.upload.uploadFiles.forEach(item => {
					// 	if (item.uid == this.dialogImageObj.uid) {
					// 		item.raw = this.newfilenow;
					// 		console.log('这里进来了嘛',item.raw)
					// 	}
					// });

					// this.$refs.upload.uploadFiles.forEach(item => {
					// 	strlist.push(item.raw);
					// });

					// this.fileList = strlist

					// this.$refs.upload.clearFiles();
					this.CoverImgUrlVisible = false;
				} else {
					this.$message(res.data.msg, '格式默认人为jpg/png');
				}
			});
		},
		init() {
			this.getprolist();
			this.getgrads();
		},
		qutionszjs(index) {
			let chiHeads = [];
			if (this.formLabelAlign.chiHeadings[index].chiHeadings) {
				this.formLabelAlign.chiHeadings[index].chiHeadings.forEach(item => {
					if (item.HE_IsJob) {
						chiHeads.push(item);
					}
				});
			}

			if (chiHeads.length > 0) {
				return '作业已布置';
			} else {
				return '作业未布置';
			}
		},
		changechince(i) {
			// console.log(i)
			return arabicToChinese(i);
		},
		// 添加资源
		addresourmane(childitm, childidx, index) {
			let resourceobj = {
				RT_GUID: '',
				cr_FileName: '',
				cr_resourcetitle: '',
				cr_OriginalFileUrl: '',
				cr_NewFileUrl: '',
				url: '',
				cr_FileSuffix: '',
				CR_Weighted: ''
			};

			this.resourceobj = resourceobj;
			// console.log(this.resourceobj,"添加资源")
			this.chiHeadactive = index;
			this.chiHeadactivechilidx = childidx;
			this.resourtitle = '添加资源';
			if (this.formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist) {
				this.resourlist = this.formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist;
			} else {
				this.resourlist = [];
			}

			// console.log(this.resourlist)
			this.resourtable = true;
		},
		setresour() {
			// 添加自选资源
			// console.log(this.resourceobj,'添加资源')
			this.resourceobj.LR_Title = this.resourceobj.cr_resourcetitle;

			if (this.idlodings || this.resourceobj.cr_resourcetitle == '') {
				this.$message('请等待文件上传完成');
				return;
			}

			let formLabelAlign = JSON.parse(JSON.stringify(this.formLabelAlign));
			if (formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist) {
				formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist.push(this.resourceobj);
			} else {
				formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist = [];
				formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist.push(this.resourceobj);
			}
			this.formLabelAlign = formLabelAlign;
			// console.log(formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist)

			this.resourtable = false;
		},
		// 资源类型
		GetResourceSelects() {
			if (this.resourceobj.url != '') {
				this.resourceobj = {
					RT_GUID: '',
					cr_FileName: '',
					cr_resourcetitle: '',
					cr_OriginalFileUrl: '',
					cr_NewFileUrl: '',
					url: '',
					cr_FileSuffix: '',
					CR_Weighted: ''
				};
			}

			let nameobj = this.rtlist.filter(ite => ite.RT_GUID == this.resourceobj.RT_GUID)[0];
			this.$refs.upload.clearFiles();
			if (nameobj.RT_ResourceTitle == '视频') {
				this.zyaccept = '.ogg,.mp4,.flv';
			} else if (nameobj.RT_ResourceTitle == '文本') {
				this.zyaccept = '.pdf';
			} else {
				this.zyaccept = '.jpg,.png,.svg';
			}

			this.idlodings = false;
		},
		// 编辑资源
		changeresourcenamege(childitm, childidx, index) {},
		// 添加自选资源
		addresourmanemyupload(childitm, childidx, index) {
			this.chiHeadactive = index;
			this.chiHeadactivechilidx = childidx;
			let resourceobj = {
				RT_GUID: '',
				cr_FileName: '',
				cr_resourcetitle: '',
				cr_OriginalFileUrl: '',
				cr_NewFileUrl: '',
				url: '',
				cr_FileSuffix: '',
				CR_Weighted: ''
			};

			this.resourceobj = resourceobj;

			this.resourtitle = '添加自选资源';
			this.getResourceType();
			this.resourtable = true;
		},
		// 上传资源 、upload事件
		beforechangefilezy() {},
		changefilezy(file, fileList) {
			if (this.resourceobj.RT_GUID == '') {
				this.$message('请选择资源类型');
				this.$refs.upload.clearFiles();
				// console.log(this.filelistszy,fileList)
			} else {
				this.beforeuploadzy(file);
			}
		},
		excehands() {
			this.$message('只能上传一张图片');
		},
		beforeuploadzy(file) {
			const fileSuffix = file.name.substring(file.name.lastIndexOf('.'));
			const whiteList = this.zyaccept.split(',');

			if (whiteList.indexOf(fileSuffix) === -1) {
				this.$message('上传文件只能是' + this.zyaccept + '格式');
				return false;
			}
			// console.log(e, '资源上传之前');
			const isLt2M = file.size / 1024 / 1024 < 1100;
			if (!isLt2M) {
				this.$message('上传文件大小不能超过 1.1g');
				return false;
			}

			if (this.resourceobj.url == '') {
				this.idlodings = true;
			} else {
				this.idlodings = false;
			}
			// console.log(this.idlodings)
		},
		// 上传资源成功
		successloadzy(response, file, fileList) {
			// console.log('成功', response);
			if (response.data.url != '') {
				this.resourceobj.cr_resourcetitle = response.data.filename;
				this.resourceobj.cr_FileName = response.data.filename;
				this.resourceobj.cr_OriginalFileUrl = response.data.url;
				this.resourceobj.cr_NewFileUrl = response.data.url;
				this.resourceobj.cr_FileSuffix = file.raw.type;
				this.resourceobj.LR_FileName = response.data.filename;
				this.resourceobj.url = response.data.url;
				this.resourceobj.LR_FileName = response.data.filename;
				this.resourceobj.LR_OriginalFileUrl = response.data.url;
				this.resourceobj.LR_NewFileUrl = response.data.url;
				this.resourceobj.LR_FileSuffix = file.raw.type;

				this.idlodings = false;

				// console.log(this.idlodings)
			}
		},
		exceeds(files, fileList) {
			this.filelistszy = [];
		},
		progresszy(event, file, fileList) {
			// console.log(event, '进度');
		},
		// 获取资源列表
		getresourcenamege(val) {
			let formLabelAlign = JSON.parse(JSON.stringify(this.formLabelAlign));
			if (formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist) {
				formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist = val;
			} else {
				formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist = [];
				formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx].Sourcelist = val;
			}
			this.formLabelAlign = formLabelAlign;

			this.resourtable = false;
		},
		// 拿资源类型
		getResourceType() {
			getGetResourceTypes().then(res => {
				if (res.data.code > 0) {
					this.rtlist = res.data.data;
				}
			});
		},
		// 获取子组件得到的值
		getqutions(val) {
			// console.log(val,"子组件的值"	);
			let formLabelAlign = JSON.parse(JSON.stringify(this.formLabelAlign));
			let objs = {};
			objs = JSON.parse(val);
			if (val) {
				if (formLabelAlign.chiHeadings[objs.HE_SortNumber].chiHeadings) {
					formLabelAlign.chiHeadings[objs.HE_SortNumber].chiHeadings.push(objs);
					this.$set(formLabelAlign.chiHeadings[objs.HE_SortNumber], 'chiHeadings', formLabelAlign.chiHeadings[objs.HE_SortNumber].chiHeadings);
				} else {
					formLabelAlign.chiHeadings[objs.HE_SortNumber].chiHeadings = [];
					formLabelAlign.chiHeadings[objs.HE_SortNumber].chiHeadings.push(objs);

					this.$set(formLabelAlign.chiHeadings[objs.HE_SortNumber], 'chiHeadings', formLabelAlign.chiHeadings[objs.HE_SortNumber].chiHeadings);
				}
				this.formLabelAlign = formLabelAlign;
				// console.log(formLabelAlign)

				this.drawertable = false;
			}
		},
		// 编辑作业
		changequtions(val) {
			let formLabelAlign = JSON.parse(JSON.stringify(this.formLabelAlign));
			let objs = {};
			objs = JSON.parse(val);
			formLabelAlign.chiHeadings[this.chiHeadactive].chiHeadings[this.chiHeadactivechilidx] = objs;

			this.formLabelAlign = formLabelAlign;
			// console.log(formLabelAlign)

			this.drawertable = false;
		},
		// 删除节点
		deletechildpanel(ite, idx) {
			this.formLabelAlign.chiHeadings[idx].chiHeadings.splice(this.formLabelAlign.chiHeadings[idx].chiHeadings.indexOf(ite), 1);
		},
		// 删除资源
		deletechildroures(childmas, index, childidx) {
			this.formLabelAlign.chiHeadings[index].chiHeadings[childidx].Sourcelist.splice(
				this.formLabelAlign.chiHeadings[index].chiHeadings[childidx].Sourcelist.indexOf(childmas),
				1
			);
		},
		// 编辑节点
		editsplens(childitm, childidx, index) {
			if (childitm.HE_IsJob) {
				// 修改作业
				// console.log('修改作业',childitm);

				this.chiHeadactive = index;
				this.chiHeadactivechilidx = childidx;
				this.chocesname = '编辑作业';
				this.drawertitle = '编辑作业';
				this.qutionsobj.sqblist = childitm.sqblist;

				this.drawertable = true;
			} else {
				// 修改节点
				// console.log('修改节点')
				this.contentstitle = '修改节点';
				this.contentobj.name = childitm.HE_HeadingsText;
				this.chiHeadactive = index;
				this.chiHeadactivechilidx = childidx;
				this.contentdialogTableVisible = true;
			}
		},
		// 添加课程
		newcourser() {
			this.$prompt('请输入章节名', '添加', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /.+/, // 判断不能为空
				inputErrorMessage: '请输入章节名'
			})
				.then(({ value }) => {
					this.formLabelAlign.chiHeadings.push({
						HE_HeadingsText: value,
						HE_IsJob: false,
						HE_Weighted: 2
					});
				})
				.catch(() => {});
		},
		changeparper(i, e) {
			// 作业
			e.stopPropagation();
			this.chocesname = '';
			// console.log(this.qutionszjs(i))
			if (this.qutionszjs(i) == '作业未布置') {
				this.chiHeadactive = i;
				this.qutionsobj.sqblist = [];

				this.drawertable = true;
			} else {
				this.$message('作业已布置,请删除作业或修改作业内容');
			}
		},
		deletepanel(item) {
			// 删除
			this.formLabelAlign.chiHeadings.splice(this.formLabelAlign.chiHeadings.indexOf(item), 1);
		},
		// 编辑章节内容
		editpanel(idx, e, name) {
			e.stopPropagation();
			this.contentstitle = '修改章节名';
			this.contentobj.name = name;
			this.chiHeadactive = idx;
			this.contentdialogTableVisible = true;
		},
		editspael() {
			// 编辑修改
			let nums1 = this.chiHeadactive;
			let nums2 = this.chiHeadactivechilidx;
			if (this.contentobj.name == '') {
				this.$message('请输入名称');
				return;
			}

			if (this.contentstitle == '修改章节名') {
				this.formLabelAlign.chiHeadings[nums1].HE_HeadingsText = this.contentobj.name;
			} else if (this.contentstitle == '修改节点') {
				this.formLabelAlign.chiHeadings[nums1].chiHeadings[nums2].HE_HeadingsText = this.contentobj.name;
			}

			this.contentdialogTableVisible = false;
		},
		// 弹框
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},

		// 添加节点
		addpanel(i, e) {
			// console.log(e)
			// e.stopPropagation();
			this.$prompt('请输入节点名', '添加', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputPattern: /.+/, // 判断不能为空
				inputErrorMessage: '请输入章节名'
			})
				.then(({ value }) => {
					// console.log(value);
					let obj = {};
					obj = {
						HE_HeadingsText: value,
						HE_IsJob: false,
						HE_Weighted: 2
					};
					let formLabelAlign = JSON.parse(JSON.stringify(this.formLabelAlign));

					if (formLabelAlign.chiHeadings[i].chiHeadings) {
						formLabelAlign.chiHeadings[i].chiHeadings.push(obj);
						this.$set(formLabelAlign.chiHeadings[i], 'chiHeadings', formLabelAlign.chiHeadings[i].chiHeadings);
					} else {
						formLabelAlign.chiHeadings[i].chiHeadings = [];
						formLabelAlign.chiHeadings[i].chiHeadings.push(obj);

						this.$set(formLabelAlign.chiHeadings[i], 'chiHeadings', formLabelAlign.chiHeadings[i].chiHeadings);
					}
					this.formLabelAlign = formLabelAlign;
					// console.log(this.formLabelAlign.chiHeadings, '目录列表');
				})
				.catch(() => {
					// console.log("取消")
					// this.$message({
					// 	type: 'info',
					// 	message: '取消输入'
					// });
				});
		},
		reduce() {
			if (this.active == 2) {
				this.active = 1;
			} else if (this.active == 1) {
				this.active = 0;
			} else {
				this.active = 0;
			}
		},
		plus() {
			if (this.active == 0) {
				this.$refs['formone'].validate(valid => {
					if (valid) {
						this.active = 1;
					} else {
						// console.log('error submit!!');
						return false;
					}
				});
			} else if (this.active == 1) {
				// this.active = 2;
				// console.log(this.formLabelAlign,"提交")
				if (this.formLabelAlign.chiHeadings.length > 0) {
					this.formLabelAlign.chiHeadings.forEach((item, index) => {
						item.HE_SortNumber = index;
						if (item.chiHeadings) {
							item.chiHeadings.forEach((itm, idx) => {
								itm.HE_SortNumber = idx;
								if (itm.Sourcelist) {
									itm.Sourcelist.forEach(its => {
										// console.log(its)
										its.cr_resourcetitle = its.LR_FileName;
										its.cr_OriginalFileUrl = its.LR_OriginalFileUrl;
										its.cr_NewFileUrl = its.LR_NewFileUrl;
										its.cr_FileName = its.LR_FileName;
										its.cr_FileSuffix = its.LR_FileSuffix;
										its.CR_Weighted = 100;
									});
								} else {
									itm.Sourcelist = [];
								}
							});
						} else {
							item.chiHeadings = [];
						}
					});
					this.active = 2;

					// console.log(this.formLabelAlign.chiHeadings,"提交")
				} else {
					this.$message('请添加章节课程信息');
				}
			} else if (this.active == 2) {
				this.formLabelAlign.CO_Learning = Number(this.formLabelAlign.CO_Learning);
				changeAddCourse(this.formLabelAlign).then(res => {
					if (res.data.code > 0) {
						this.$message.success(res.data.msg);
						this.$router.push('/course/cours/coursemanagement');
					}
				});
				// console.log('提交');
			}
		},
		submitForm(formName) {
			this.$refs[formName].validate(valid => {
				if (valid) {
					// console.log('提交');
				} else {
					// console.log('error submit!!');
					return false;
				}
			});
		},
		beforeAvatarUpload(file) {
			// console.log(file);
			const fileSuffix = file.name.substring(file.name.lastIndexOf('.'));
			const whiteList = this.zyaccept.split(',');
			const isLt2M = file.size / 1024 / 1024 < 2;
			const isJPG = true;

			if (whiteList.indexOf(fileSuffix) === -1) {
				this.$message('上传文件只能是' + this.zyaccept + '格式');
				this.fileList = [];
				this.$refs.upload.clearFiles();
				this.isJPG = false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				this.fileList = [];
			}

			return isJPG && isLt2M;
		},
		handleRemove(file, fileList) {
			// console.log(file, fileList);
			this.fileList = fileList;
		},
		clenrsa() {
			// this.filelists = []
			this.fileList.splice(this.fileList.indexOf(this.flefl), 1);
			this.$refs.upload.clearFiles();
			this.CoverImgUrlVisible = false;
		},
		handleAvatarSuccess(res, file, fileList) {
			// console.log(file,"文件");
			if (res.code > 0) {
				this.formLabelAlign.CO_CoverImgUrl = res.data.url;
				this.fileList = [
					{
						url: res.data.baseurl
					}
				];
				this.dialogImageUrl = file.url;
				this.dialogImageObj = file;
				this.CoverImgUrlVisible = true;
			} else {
				this.$message('上传失败请重新上传');
			}
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
		getprolist() {
			this.prolist = [];

			if (localStorage.getItem('uiguid') == 'f2b9986b57074d2cb2dadd07f6ee62bb') {
				getGetProfList().then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.formLabelAlign.CA_GUID !== '') {
							this.getpolist();
						}
					}
				});
			} else {
				GetzyProfList(localStorage.getItem('siguid')).then(res => {
					// console.log(res.data.data)
					if (res.data.code > 0) {
						this.prolist = res.data.data;
						if (this.formLabelAlign.CA_GUID !== '') {
							this.getpolist();
						}
					}
				});
			}
		},
		getpolist() {
			getPositionList(this.formLabelAlign.CA_GUID).then(res => {
				if (res.data.code > 0) {
					this.polist = res.data.data;
				}
			});
		},
		getgrads() {
			changeGradeGet().then(res => {
				// console.log("获取等级",res)
				this.gradeget = res.data.data;
			});
		}
	},
	components: {
		titles,
		TinymceEditor,
		chiocesqutions,
		resourcemanege,
		VueCropper
	}
};
</script>
